.root {
  background: var(--color-background);
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
}

// v3 workflow stepper — design #F8FAFC bar, active step #0F172A pill
.workflow {
  align-items: center;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  flex-shrink: 0;
  gap: 0;
  justify-content: space-between;
  list-style: none;
  margin: 0;
  overflow-x: auto;
  padding: 10px 12px;
}

.workflow-item {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  gap: 0;
}

.workflow-chevron {
  color: #94a3b8;
  font-size: 10px;
  font-weight: 500;
  margin: 0 2px;
}

.workflow-step {
  align-items: center;
  border-radius: 6px;
  display: inline-flex;
  gap: 4px;
  padding: 3px 5px;
}

.workflow-step-is-active {
  background: #121926;
}

.workflow-num {
  align-items: center;
  background: #e2e8f0;
  border-radius: 7px;
  color: #64748b;
  display: inline-flex;
  font-size: 8px;
  font-weight: 700;
  height: 14px;
  justify-content: center;
  width: 14px;
}

.workflow-step-is-active .workflow-num {
  background: #ffffff;
  color: #121926;
}

.workflow-label {
  color: #64748b;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
}

.workflow-step-is-active .workflow-label {
  color: #ffffff;
}

.phase-header {
  align-items: center;
  display: flex;
  gap: 12px;
  padding: 12px 16px;
}

.back-button {
  align-items: center;
  background: transparent;
  border: 0;
  color: #0f172a;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  padding: 0;
}

.more-button {
  align-items: center;
  background: transparent;
  border: 0;
  color: #64748b;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  padding: 0;
}

.phase-titles {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.title {
  color: #0f172a;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
}

.subtitle {
  color: #64748b;
  font-size: 11px;
  line-height: 1.3;
  margin: 0;
}
